export default __webpack_public_path__ + "54d8c6d.png";